import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { displayAmount, makeTitleCase, isSojournerProperty, getSojournerBookingUrl } from "../utils/helpers";
import BookingModal from "./Modals/BookingModal";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SingleRoomTile({hotel, room, index, params = null, isBlocked = false}) {
  const [showBookingModal, setShowBookingModal] = useState(false)
  const isRoomActive = room.active !== false && hotel?.active !== false;

  const handleBookNow  = (e) => {
    e.preventDefault();
    if (!isRoomActive || isBlocked) return;
    if (isSojournerProperty(hotel?.slug) || isSojournerProperty(hotel?.bookingId) || isSojournerProperty(room?.slug)) {
      window.location.href = getSojournerBookingUrl(params?.adult);
      return;
    }
    if(params){
      window.location = `/checkout?hotel=${hotel.slug}&room=${room.slug}&arrival=${params.arrival}&departure=${params.departure}&adult=${params.adult}&children=${params.children}`
    }
else{
setShowBookingModal(true)
}
  }
  let { currency } = useSelector(state=>state.app)
  let price = currency === "USD" ? displayAmount(room.priceUsd,0,"$") :  displayAmount(room.priceNgn)
  let promoPrice = currency === "USD" ? displayAmount(room.promoPriceUsd,0,"$") :  displayAmount(room.promoPriceNgn)
let isNotPromo = (promoPrice === "₦0" || promoPrice === "$0")
  const handleCheckout = (data) => {
    if (isSojournerProperty(hotel?.slug) || isSojournerProperty(hotel?.bookingId) || isSojournerProperty(room?.slug)) {
      window.location.href = getSojournerBookingUrl(data?.adult);
      return;
    }
    window.location = `/checkout?hotel=${hotel.slug}&room=${room.slug}&arrival=${data.arrival}&departure=${data.departure}&adult=${data.adult}&children=${data.children}`
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    autoplay:true,
    autoplaySpeed:2000,
  };

  return (
    <>
    <div 
      className={`rooms2 mb-90 animate-box ${index%2 == 1 ? "left":null}`} 
      data-animate-effect="fadeInUp"
      style={!isRoomActive ? { filter: "grayscale(100%)", opacity: 0.55 } : {}}
    >
    <figure>
    <Slider {...settings}>
        {room.images?.map(image => 
            <img src={image} alt={room.name} className="img-fluid" />
          )}
    </Slider>
    </figure>
     {/* <figure>
            <img src={room.images[0]} alt={room.name} className="img-fluid" />
          </figure> */}
      <div className="caption">
        {
         isNotPromo && <h3 className="inline">{price}</h3>
        }
        { !isNotPromo && <>
        <h3 className="text-muted inline"><del>{price}</del> </h3>
        <div className="flex " style={{display:"flex"}}>
        <h3 className="inline"> {promoPrice}<span>/ Night</span></h3>
        <span className="badge badge-pill badge-default badge-dark text-white mx-1 pt-2" style={{fontSize:10}}> {hotel.slug === "genesis-reventon-park" ? "10%":hotel.slug === "genesis-jersey-estate"?"10%" : "10%"  } discount applied</span>
        </div>
        </>}
        <h4>
          <a 
            href={isRoomActive ? (params?`/room/${room.slug}?ref=${params.ref}&arrival=${params.arrival}&departure=${params.departure}&adult=${params.adult}&children=${params.children}` :`/room/${room.slug}`) : "#"}
            onClick={!isRoomActive ? (e) => e.preventDefault() : undefined}
            style={!isRoomActive ? { cursor: "not-allowed" } : {}}
          >
            {makeTitleCase(room.name)}
          </a>
        </h4>
        <p>
          {room?.description}
        </p>
        <div className="row room-facilities">
          { room.name === "2 bedroom apartment" 
          ?  <>
          <div className="col-md-4">
            <ul>
              <li> 2-4 Persons  </li>
              <li>  Security</li>
              <li> Relaxation Area</li>
            </ul>
          </div>
          <div className="col-md-4">
            <ul>
            <li>High speed WiFi </li>
              <li>Swimming Pool</li>
              <li> Constant Power</li>
            </ul>
          </div>
          <div className="col-md-4">
          <ul>
            <li>Working Kitchen </li>
              <li>Cooking Gas</li>
              <li>Backup Generator</li>
            </ul>
          </div>
            </>
            : room.name === "Penthouse" 
            ?
            <>
              <div className="col-md-4">
            <ul>
              <li> 2-4 Persons  </li>
              <li>  Security</li>
              <li> Relaxation Area</li>
            </ul>
          </div>
          <div className="col-md-4">
            <ul>
            <li>High speed WiFi </li>
              <li>Swimming Pool</li>
              <li> Constant Power</li>
            </ul>
          </div>
          <div className="col-md-4">
          <ul>
            <li>Working Kitchen </li>
              <li>Cooking Gas</li>
              <li>Backup Generator</li>
            </ul>
          </div>
            </>
            : room.name === "3 bedroom apartment" 
           ? <>
            <div className="col-md-4">
            <ul>
              <li> 3-6 Persons  </li>
              <li>  Security</li>
              <li> Relaxation Area</li>
            </ul>
          </div>
          <div className="col-md-4">
            <ul>
            <li>High speed WiFi </li>
              <li>Swimming Pool</li>
              <li> Constant Power</li>
            </ul>
          </div>
          <div className="col-md-4">
          <ul>
            <li>Working Kitchen </li>
              <li>Cooking Gas</li>
              <li>Backup Generator</li>
            </ul>
          </div>
          </>
          :
          <>
            <div className="col-md-4">
            <ul>
              <li>
                <i className="flaticon-group" /> 1-2 Persons
              </li>
              <li>
                <i className="flaticon-wifi" /> Gymnasium
              </li>
            </ul>
          </div>
          <div className="col-md-4">
            <ul>
              <li>
              <i className="flaticon-bed" /> Twin Bed
              </li>
              <li>
                <i className="flaticon-breakfast" /> Car Park
              </li>
            </ul>
          </div>
          <div className="col-md-4">
            <ul>
              <li>
                <i className="flaticon-clock-1" /> 200 sqft room
              </li>
             {hotel.slug != "genesis-place" && <li>
                <i className="flaticon-swimming" /> Swimming Pool
              </li>}
            </ul>
          </div>
          </>
          }
        
        </div>
        <hr className="border-2" />
        <div className="info-wrapper">
          <div className="more">
            <a 
              href={isRoomActive ? (params?`/room/${room.slug}?ref=${params.ref}&arrival=${params.arrival}&departure=${params.departure}&adult=${params.adult}&children=${params.children}` :`/room/${room.slug}`) : "#"} 
              onClick={!isRoomActive ? (e) => e.preventDefault() : undefined}
              className="link-btn" 
              tabIndex={0}
              style={!isRoomActive ? { cursor: "not-allowed" } : {}}
            >
              See Details <i className="ti-arrow-right" />
            </a>
          </div>
          <div
            className="butn-dark"
            onClick={handleBookNow}
            style={{
              cursor: (!isRoomActive || isBlocked) ? "not-allowed" : "pointer",
              opacity: (!isRoomActive || isBlocked) ? 0.65 : 1,
              backgroundColor: !isRoomActive ? "#777" : undefined,
              borderColor: !isRoomActive ? "#777" : undefined,
            }}
            aria-disabled={!isRoomActive || isBlocked}
            title={!isRoomActive ? "This room is currently unavailable" : (isBlocked ? "Unavailable for the selected dates" : "")}
          >
            {" "}
            <span>{!isRoomActive ? "Unavailable" : (isBlocked ? "Unavailable" : "Book Now")}</span>
          </div>
        </div>
      </div>
    </div>
    {showBookingModal &&  <BookingModal show={showBookingModal} close={()=>setShowBookingModal(false)} checkout={handleCheckout} />}
    </>
  );
}

export default SingleRoomTile;
